module.exports = __webpack_public_path__ + "static/media/Video Game Guy.c2d50ca4.jpg";